import { darken } from '@theme-ui/color'

const breadcrumbs: any = {
  breadcrumb: {
    color: 'primary',
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
      color: darken('primary', 0.15),
    },
    '&:active': {
      color: darken('primary', 0.18),
      textDecoration: 'underline',
    },
  },
  ul: {
    listStyle: 'none',
    m: 0,
    p: 0,
  },
  li: {
    ':after': {
      content: "'\\002F'",
      color: 'secondary',
      ml: 3,
    },
    ':last-of-type:after': {
      content: "''",
    },
    p: 2,
  },
}

export default breadcrumbs
